<template>
  <div>
    <span
        no-gutters
        class="hb-font-caption"
        >{{ localTime }}
      </span>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: 'DoNotRentAddedAtRenderer',
  data() {
    return {
    };
  },
  computed: {
    localTime() {
      return moment.utc(this.params.data.dnr_added_at).local().format('MMM D, YYYY @ hh:mma');
    }
  },
};
</script>